import { render, staticRenderFns } from "./cockpit.vue?vue&type=template&id=5fb66d7c&scoped=true"
import script from "./cockpit.vue?vue&type=script&lang=js"
export * from "./cockpit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb66d7c",
  null
  
)

export default component.exports